"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
var _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.i18n = void 0;
var i18next_1 = __importDefault(require("i18next"));
var w = window;
var translations = w.generatorTranslations;
var language = (_b = document.documentElement.lang) !== null && _b !== void 0 ? _b : 'en';
i18next_1.default.init({
    lng: language,
    resources: (_a = {},
        _a[language] = {
            translation: translations
        },
        _a),
    returnObjects: true
});
exports.i18n = i18next_1.default;
exports.default = i18next_1.default.t.bind(i18next_1.default);
